import COUNTRIES from "./../constants/countries";
import US_STATES, { ALL_USA_STATE } from "./../constants/usStates";
import TYPE from "./../constants/searchType";
import FIELDS_NGO from "./../constants/ngo";
import { FIELDS_NEWS } from "./../constants/news";
import { FIELDS_BUSINESS, CATEGORY_BUSINESS, FIELDS_TYPES } from "./../constants/business";
import { FIELDS_HOTSPOTS } from "../constants/hotSpots";
import { FIELDS_GREENSPOTS } from "../constants/greenSpots";
import FIELDS_BLOG from "../constants/blog";


export const getOptionsLocalized = (options) => {

    // eslint-disable-next-line default-case
    switch (options) {
        case "countries":
            return COUNTRIES;
        case "states":
            return [ALL_USA_STATE, ...US_STATES];
        case "usState":
        case "state":
            return US_STATES;
        case "businessFields":
            return FIELDS_BUSINESS;
        case "business":
            return FIELDS_BUSINESS;
        case "category":
            return CATEGORY_BUSINESS;
        case "organizationFields":
            return FIELDS_NGO;
        case "NGO":
            return FIELDS_NGO;
        case "hotSpot":
            return FIELDS_HOTSPOTS
        case "greenSpot":
            return FIELDS_GREENSPOTS
        case "government":
            return [{ value: "all", label: 'all' }]
        case "media":
            return [{ value: "all", label: 'all' }]
        case "searchType":
            return TYPE;
        case "type":
            return FIELDS_TYPES /// refactor
        case "fields":
            return FIELDS_NGO
        case "fieldsHotSpots":
            return FIELDS_HOTSPOTS
        case "hotSpotFields":
            return FIELDS_HOTSPOTS
        case "greenSpotFields":
            return FIELDS_GREENSPOTS
        case "newsFields":
            return FIELDS_NEWS;
        case "blogFields":
            return FIELDS_BLOG;
        case "spotProp":
            return [
                { value: "name", label: "Name" },
                { value: "url", label: "Url" },
            ]
    }
};
